import React, { Component } from "react";
import { FastAverageColor } from "fast-average-color";
import { bindActionCreators } from "redux";
import { capitalizeFirstLetter } from "../../../../utils/common";
import { history } from "../../../../store/configure/configureStore";

import connect from "react-redux/es/connect/connect";
import {
  getDeviceList,
  getStatusList,
  getBannerScreenList,
  getSubscriptionList,
} from "../../../../store/master/masterActions";
import {
  updateBanner,
  getBannerById,
  setBannerBackgroundColor,
  resetBannerBackgroundColor,
} from "../../../../store/BannerManagement/BannerManagementActions";

import UpdateBannerView from "./UpdateBannerView";

class UpdateBannerContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInputElement: {
        title: false,
        subTitle: false,
        primaryBtn: false,
        secondaryBtn: false,
      },
      // fields: {
      //   title: "",
      //   subTitle: "",
      //   primaryBtnTitle: "",
      //   secondaryBtnTitle: "",
      //   status: {},
      // },
      // editField: {
      //   title: { color: "", visibility: "", active: false },
      //   subTitle: { color: "", visibility: "", active: false },
      //   primaryBtnTitle: { color: "", visibility: "", active: false },
      //   secondaryBtnTitle: { color: "", visibility: "", active: false },
      // },
      newFields: {
        title: {
          title: "",
          color: "",
          visibility: { label: "show", value: "show" },
          fontSize: "14",
          modalTitle: "",
          active: false,
        },
        subTitle: {
          subTitle: "",
          color: "",
          visibility: { label: "show", value: "show" },
          fontSize: "12",
          modalTitle: "",
          active: false,
        },
        primaryBtnTitle: {
          primaryBtnTitle: "",
          color: "",
          visibility: { label: "show", value: "show" },
          fontSize: "12",
          modalTitle: "",
          active: false,
          BtnActionURL: "",
          type: "button",
        },
        secondaryBtnTitle: {
          secondaryBtnTitle: "",
          color: "",
          visibility: { label: "show", value: "show" },
          fontSize: "12",
          modalTitle: "",
          active: false,
          BtnActionURL: "",
          type: "button",
        },
      },
      imageBackgroundColor: "",
      prevImageBackgroundColor: "",
      showBackGroundColorIcon: false,
      prevFields: {},
      device: null,
      status: null,
      checkedItems: [],
      bannerScreen: null,
      showModal: false,
      showImageResolutionWarningModal: false,
      showImageBackgroundColorModal: false,
      showColorModalOnClickIcon: false,
      file: null,
      prevFile: null,
      fileInput: null,
      prevFileInput: null,
    };

    this.handleDoubleClickText = this.handleDoubleClickText.bind(this);
    this.handleInputToTextOnFocusOut =
      this.handleInputToTextOnFocusOut.bind(this);
    //
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDiscardFile = this.handleDiscardFile.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputChangeOfActiveModal =
      this.handleInputChangeOfActiveModal.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleBackgroundColorChange =
      this.handleBackgroundColorChange.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleDeviceChange = this.handleDeviceChange.bind(this);
    this.onChangeBannerScreenOption =
      this.onChangeBannerScreenOption.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    //
    this.onClickSubmit = this.onClickSubmit.bind(this);
    //
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    //
    this.handleShowImageResolutionWarningModal =
      this.handleShowImageResolutionWarningModal.bind(this);
    this.handleCloseImageResolutionWarningModal =
      this.handleCloseImageResolutionWarningModal.bind(this);
    //
    this.handleShowImageBackgroundColorModal =
      this.handleShowImageBackgroundColorModal.bind(this);
    //
    this.handleOnClickIconShowImageBackgroundColorModal =
      this.handleOnClickIconShowImageBackgroundColorModal.bind(this);
    this.handleOnClickIconConfirmImageBackgroundColorModal =
      this.handleOnClickIconConfirmImageBackgroundColorModal.bind(this);
    this.handleOnClickCancelImageBackgroundColorModal =
      this.handleOnClickCancelImageBackgroundColorModal.bind(this);
    //
    this.handleResetOnCancelClick = this.handleResetOnCancelClick.bind(this);
    this.handleOnSaveClick = this.handleOnSaveClick.bind(this);
    this.handleOnClickCancel = this.handleOnClickCancel.bind(this);
  }

  componentDidUpdate(prevProps) {
    // console.log(this.state);

    // Check if deviceList has changed and device is null
    if (this.state.device === null) {
      this.props.deviceList.forEach((item) => {
        if (item.name === "Iphone 11") {
          this.setState({
            device: item,
          });
        }
      });
    }

    if (prevProps.bannerById !== this.props.bannerById) {
      this.handlePreFillValuesInState();
      this.handlePrefillForCheckedItems();
    }
  }

  componentDidMount() {
    const { id } = this.props.match?.params; //get id of banner from url

    // localStorage.removeItem("bgColor");
    this.props.resetBannerBackgroundColor();

    this.props.getBannerById(id);
    this.props.getSubscriptionList();
    this.props.getDeviceList();
    this.props.getStatusList();
    this.props.getBannerScreenList();
  }

  componentWillUnmount() {}

  handlePreFillValuesInState = () => {
    // console.log("bannerById", this.props.bannerById);
    const checkedItems = this.handlePrefillForCheckedItems();
    const {
      button = [],
      subTitle = {},
      title = {},
      status = {},
      bannerTitle = "",
      presignedUrl = "",
      bannerScreenId = {},
      subscriptionId = [],
      imageBackgroundColor = "",
    } = this.props?.bannerById || {};

    const primaryButton = button[0];
    const secondaryButton = button[1];

    // localStorage.setItem("bgColor", imageBackgroundColor);
    this.props.setBannerBackgroundColor(imageBackgroundColor);

    this.setState(
      (prev) => ({
        ...prev,
        newFields: {
          title: {
            ...prev.newFields.title,
            title: title?.text,
            color: title?.color,
            visibility: {
              label: `${title?.visible}`,
              value: `${title?.visible}`,
            },
            fontSize: title?.fontSize || 14,
          },
          subTitle: {
            ...prev.newFields.subTitle,
            subTitle: subTitle?.text,
            color: subTitle?.color,
            visibility: {
              label: `${subTitle?.visible}`,
              value: `${subTitle?.visible}`,
            },
            fontSize: subTitle?.fontSize || 12,
          },
          primaryBtnTitle: {
            ...prev.newFields.primaryBtnTitle,
            primaryBtnTitle: primaryButton?.title,
            color: primaryButton?.color,
            visibility: {
              label: `${primaryButton?.visible}`,
              value: `${primaryButton?.visible}`,
            },
            fontSize: primaryButton?.fontSize || 12,
            BtnActionURL: primaryButton?.buttonUrl,
          },
          secondaryBtnTitle: {
            ...prev.newFields.secondaryBtnTitle,
            secondaryBtnTitle: secondaryButton?.title,
            color: secondaryButton?.color,
            visibility: {
              label: `${secondaryButton?.visible}`,
              value: `${secondaryButton?.visible}`,
            },
            fontSize: secondaryButton?.fontSize || 12,
            BtnActionURL: secondaryButton?.buttonUrl,
          },
        },
        status: { label: `${status?.status}`, value: `${status?._id}` },
        fileInput: presignedUrl,
        imageBackgroundColor: imageBackgroundColor,
        prevImageBackgroundColor: imageBackgroundColor,
        showBackGroundColorIcon: imageBackgroundColor && true,
        checkedItems: checkedItems,
        bannerScreen: bannerScreenId
          ? {
              label: `${bannerScreenId?.label}`,
              value: `${bannerScreenId?._id}`,
            }
          : null,
      }),
      () => {
        // console.log("prefill", this.state);
      }
    );
  };

  //this is used for marking checked in check list if data is available
  handlePrefillForCheckedItems = () => {
    const {
      subscriptionId = [],
      sahaj = false,
      sky = false,
    } = this.props?.bannerById || {};

    // Transform subscriptionId into the desired format
    const subscriptionItems = subscriptionId.map((item) => ({
      id: item._id,
      name: item.name,
      isFlagItem: false,
    }));

    // Create flag items
    const flagItems = [
      {
        id: "sahaj-id",
        name: "Sahaj",
        isFlagItem: true,
      },
      {
        id: "sky-id",
        name: "Sky",
        isFlagItem: true,
      },
    ];

    // Filter flag items based on their respective flags
    const checkedFlagItems = flagItems.filter((flagItem) => {
      const flagValue = this?.props?.bannerById?.[flagItem?.name.toLowerCase()];
      return flagValue; // Include item if flag value is true
    });

    // Combine subscription items and checked flag items
    const checkedItems = [...subscriptionItems, ...checkedFlagItems];

    // console.log("checkedItems", checkedItems);
    return checkedItems;
  };

  // handleDoubleClickText = (key) => {
  //   this.setState((prevState) => ({
  //     ...prevState,
  //     showInputElement: {
  //       ...prevState.showInputElement,
  //       [key]: true,
  //     },
  //   }));
  // };

  handleDoubleClickText = (key) => {
    this.setState((prevState) => {
      // Create a new object where only the matching key is set to true, others are false
      const updatedShowInputElement = Object.keys(
        prevState.showInputElement
      ).reduce((acc, currentKey) => {
        acc[currentKey] = currentKey === key;
        return acc;
      }, {});

      return {
        ...prevState,
        showInputElement: updatedShowInputElement,
      };
    });
  };

  resetShowInputElement = () => {
    this.setState((prev) => ({
      ...prev,
      showInputElement: {
        title: false,
        subTitle: false,
        primaryBtn: false,
        secondaryBtn: false,
      },
    }));
  };

  //-------------------when clicked outside of input field
  handleInputToTextOnFocusOut = (key) => {
    // console.log("clicked");
    this.setState((prevState) => ({
      ...prevState,
      showInputElement: {
        ...prevState.showInputElement,
        [key]: false,
      },
    }));
  };

  //-------------------File selection

  // handleFileChange(event, bannerDimensions) {
  //   const file = event.target.files[0];

  //   if (file) {
  //     console.log("file", file);

  //     const reader = new FileReader();

  //     // Load the file and update fileInput state
  //     reader.onloadend = () => {
  //       this.setState({
  //         fileInput: reader.result,
  //       });

  //       // Create a new image to get its dimensions
  //       const img = new Image();
  //       img.onload = () => {
  //         const imageWidth = img.width;
  //         const imageHeight = img.height;

  //         console.log(`Image dimensions: ${imageWidth}x${imageHeight}`);

  //         // Compare image dimensions with bannerDimensions
  //         if (
  //           (imageWidth < 1920 && imageHeight < 1080) ||
  //           imageWidth < 1920 ||
  //           imageHeight < 1080
  //         ) {
  //           // Call the warning modal function if dimensions are smaller
  //           this.handleShowImageResolutionWarningModal();
  //           this.setState((prev) => ({
  //             ...prev,
  //             showBackGroundColorIcon: true,
  //           }));
  //         } else {
  //           this.setState((prev) => ({
  //             ...prev,
  //             imageBackgroundColor: "",
  //             showBackGroundColorIcon: false,
  //           }));
  //         }
  //       };

  //       img.src = reader.result; // Set the image source to the file data URL
  //     };

  //     reader.readAsDataURL(file); // Read the file as a data URL

  //     // Update the file in the state
  //     this.setState((prev) => ({
  //       ...prev,
  //       file: event.target.files[0],
  //     }));
  //   }
  // }

  handleFileChange(event, bannerDimensions) {
    const file = event.target.files[0];

    if (file) {
      console.log("file", file);

      const reader = new FileReader();

      reader.onloadend = () => {
        this.setState((prev) => ({
          fileInput: reader.result,
          prevFileInput: this.state?.fileInput, //update with current state
        }));

        const img = new Image();
        img.onload = () => {
          const imageWidth = img.width;
          const imageHeight = img.height;

          console.log(`Image dimensions: ${imageWidth}x${imageHeight}`);

          // Compare image dimensions with bannerDimensions
          if (
            (imageWidth < 1920 && imageHeight < 1080) ||
            imageWidth < 1920 ||
            imageHeight < 1080
          ) {
            // Call the warning modal function if dimensions are smaller
            this.handleShowImageResolutionWarningModal();
            this.setState((prev) => ({
              ...prev,
              showBackGroundColorIcon: true,
            }));

            // Use Fast Average Color to set the background color
            const fac = new FastAverageColor();
            fac
              .getColorAsync(img)
              .then((color) => {
                this.setState(
                  (prev) => {
                    // localStorage?.setItem("bgColor", color.hex);
                    this.props.setBannerBackgroundColor(color.hex);
                    return {
                      ...prev,
                      imageBackgroundColor: color.hex, // Set the average color as background
                      prevImageBackgroundColor: prev.imageBackgroundColor, // Set previous color
                    };
                  },
                  () => {
                    // console.log("color change", this.state); // Log after the state has been updated
                  }
                );
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            this.setState(
              (prev) => ({
                ...prev,
                imageBackgroundColor: "",
                showBackGroundColorIcon: false,
              })
              // () => console.log("new state", this.state)
            );
          }
        };

        img.src = reader.result;
      };

      reader.readAsDataURL(file);

      this.setState(
        (prev) => ({
          ...prev,
          file: event.target.files[0],
          prevFile: prev?.file,
        }),
        () => {
          // Reset file input value to allow re-uploading the same file
          event.target.value = null;
        }
      );
    }
  }

  // Handle the "No" action - Discard the file
  handleDiscardFile = () => {
    const { presignedUrl = "", imageBackgroundColor = "" } =
      this.props?.bannerById || {};
    this.setState((prev) => {
      // localStorage.setItem("bgColor", prev?.prevImageBackgroundColor);
      this.props.setBannerBackgroundColor(prev?.prevImageBackgroundColor);
      return {
        file: prev.prevFile,
        // fileInput: this.state?.fileInput ? this.state?.fileInput : presignedUrl,
        fileInput: prev?.prevFileInput || presignedUrl,
        imageBackgroundColor: prev?.prevFileInput
          ? prev?.prevImageBackgroundColor
          : imageBackgroundColor || "",
        showBackGroundColorIcon:
          (!imageBackgroundColor && !this.state?.prevImageBackgroundColor) ||
          (imageBackgroundColor && !this.state?.prevImageBackgroundColor)
            ? false
            : true,
      };
    });
  };

  //-------------------Input change
  handleInputChange = ({ target }) => {
    const field = target.name;
    // console.log(this.state.fields);
    // this.setState({
    //   fields: { ...this.state.fields, [field]: target.value },
    // });

    this.setState((prevState) => ({
      newFields: {
        ...prevState.newFields,
        [field]: {
          ...prevState.newFields[field],
          [field]: capitalizeFirstLetter(target?.value),
        },
      },
    }));
  };

  // resetToDefaultFontSize = (key) => {
  //   const fontSizeValues = [
  //     { title: "16" },
  //     { subTitle: "14" },
  //     { primaryBtnTitle: "14" },
  //     { secondaryBtnTitle: "14" },
  //   ];

  //   const item = fontSizeValues.find((item) => item.hasOwnProperty(key));
  //   // console.log("reset call", item);

  //   if (item) {
  //     return item[key];
  //   }
  // };

  handleInputChangeOfActiveModal = ({ target }) => {
    const field = target.name;

    // Find the active key
    const activeKey = Object.keys(this.state.newFields).find(
      (key) => this.state.newFields[key].active === true
    );

    this.setState((prevState) => ({
      newFields: {
        ...prevState.newFields,
        [activeKey]: {
          ...prevState.newFields[activeKey],
          [field]: target?.value,
        },
      },
    }));
  };

  //-------------------color change
  handleColorChange = (e) => {
    const newColor = e.target.value;

    // this.setState((prev) => ({
    //   editField: Object.keys(prev.editField).reduce((acc, key) => {
    //     console.log(key);
    //     // Check if the field is active
    //     if (prev.editField[key].active) {
    //       acc[key] = {
    //         ...prev.editField[key],
    //         color: newColor,
    //       };
    //     } else {
    //       acc[key] = prev.editField[key];
    //     }
    //     return acc;
    //   }, {}),
    // }));

    this.setState((prev) => ({
      newFields: Object.keys(prev.newFields).reduce((acc, key) => {
        // console.log(key);
        // Check if the field is active
        if (prev.newFields[key].active) {
          acc[key] = {
            ...prev.newFields[key],
            color: newColor,
          };
        } else {
          acc[key] = prev.newFields[key];
        }
        return acc;
      }, {}),
    }));
  };

  handleBackgroundColorChange = (e) => {
    const newColor = e.target.value;
    // console.log("newColor", newColor);
    this.setState((prev) => ({
      ...prev,
      imageBackgroundColor: newColor,
      // prevImageBackgroundColor: prev?.imageBackgroundColor,
    }));
  };

  handleVisibilityChange = (val) => {
    const value = val;

    // this.setState((prev) => ({
    //   editField: Object.keys(prev.editField).reduce((acc, key) => {
    //     console.log(key);
    //     // Check if the field is active
    //     if (prev.editField[key].active) {
    //       acc[key] = {
    //         ...prev.editField[key],
    //         visibility: value,
    //       };
    //     } else {
    //       acc[key] = prev.editField[key];
    //     }
    //     return acc;
    //   }, {}),
    // }));

    this.setState((prev) => ({
      newFields: Object.keys(prev.newFields).reduce((acc, key) => {
        console.log(key);
        // Check if the field is active
        if (prev.newFields[key].active) {
          acc[key] = {
            ...prev.newFields[key],
            visibility: value,
          };
        } else {
          acc[key] = prev.newFields[key];
        }
        return acc;
      }, {}),
    }));
  };

  handleOnSaveClick = () => {
    //just close the modal and reset the active state to false , bcs state already stored
    this.setState((prev) => ({
      showModal: false,
      newFields: Object.keys(prev.newFields).reduce((acc, key) => {
        acc[key] = {
          ...prev.newFields[key],
          active: false,
        };
        return acc;
      }, {}),
    }));
  };

  handleResetOnCancelClick = (callback) => {
    //when modal closed without clicking saving button
    this.setState(
      (prev) => ({
        newFields: Object.keys(prev.newFields).reduce((acc, key) => {
          // Check if the field is active
          if (prev.newFields[key].active) {
            acc[key] = {
              ...prev.newFields[key],
              visibility: "",
              color: "",
            };
          } else {
            acc[key] = prev.newFields[key];
          }
          return acc;
        }, {}),
      }),
      () => callback()
    );
  };

  handleStatusChange = (val) => {
    this.setState((prev) => ({
      ...prev,
      status: val,
    }));
  };

  onChangeBannerScreenOption = (val) => {
    // console.log(val);
    this.setState((prev) => ({
      ...prev,
      bannerScreen: val,
    }));
  };

  //-------------------handle Device Change
  handleDeviceChange = (val) => {
    const selectedDevice = this.props.deviceList?.find(
      (item) => item?.name === val?.label
    );
    this.setState((prev) => ({
      ...prev,
      device: selectedDevice,
    }));
  };

  //-------------------handle checkbox Change
  handleCheckBoxChange = (id, name, isChecked, isFlagItem = false) => {
    this.setState(
      (prevState) => {
        const { checkedItems } = prevState;
        if (isChecked) {
          // Add item if checked
          return {
            checkedItems: [...checkedItems, { id, name, isFlagItem }],
          };
        } else {
          // Remove item if unchecked
          return {
            checkedItems: checkedItems.filter((item) => item.id !== id),
          };
        }
      },
      () => console.log("onchange checked", this.state.checkedItems)
    );
  };

  //-------------------handle Modal

  modalHeaderTitle = [
    { title: "Title Edit" },
    { subTitle: "Sub-Title Edit" },
    { primaryBtnTitle: "Primary Button Edit" },
    { secondaryBtnTitle: "Secondary Button Edit" },
  ];

  getModalHeaderTitle = (key) => {
    //get modal header title
    const item = this.modalHeaderTitle.find((item) => item[key]);
    return item;
  };

  //-------------------handle setPrevious state (these state will used for cancel btn to set previous values)
  handleSetPreviousValues = () => {
    this.setState(() => ({
      prevFields: this.state.newFields,
    }));
  };

  handleShowModal = (key) => {
    this.handleSetPreviousValues();
    const modalHeader = this.getModalHeaderTitle(key);
    // console.log("modalHeader", modalHeader[key]);
    this.setState((prev) => ({
      showModal: true,
      newFields: {
        ...prev.newFields,
        [key]: {
          ...prev.newFields[key],
          modalTitle: modalHeader[key], //modal header title
          active: true,
        },
      },
    }));
  };

  handleCloseModal = () => {
    // this.handleResetOnCancelClick(() => {
    //   this.setState((prev) => ({
    //     showModal: false,
    //     newFields: Object.keys(prev.newFields).reduce((acc, key) => {
    //       acc[key] = {
    //         ...prev.newFields[key],
    //         modalTitle: "",
    //         active: false,
    //       };
    //       return acc;
    //     }, {}),
    //   }));
    // });

    this.setState((prev) => ({
      showModal: false,
      newFields: Object.keys(prev.newFields).reduce((acc, key) => {
        acc[key] = {
          ...prev.newFields[key],
          modalTitle: "",
          active: false,
        };
        return acc;
      }, {}),
    }));
  };

  handleShowImageResolutionWarningModal = () => {
    this.setState((prev) => ({
      ...prev,
      showImageResolutionWarningModal: true,
      // imageBackgroundColor: "",
    }));
  };

  handleCloseImageResolutionWarningModal = () => {
    this.setState((prev) => ({
      ...prev,
      showImageResolutionWarningModal: false,
    }));
  };

  handleShowImageBackgroundColorModal = () => {
    this.setState((prev) => ({
      ...prev,
      showImageResolutionWarningModal: false,
      showImageBackgroundColorModal: true,
    }));
  };

  //---------------this is for color modal which will pop up onClick of color icon
  handleOnClickIconShowImageBackgroundColorModal = () => {
    this.setState((prev) => ({
      ...prev,
      showColorModalOnClickIcon: true,
    }));
  };

  handleOnClickIconConfirmImageBackgroundColorModal = () => {
    // localStorage?.setItem("bgColor", this.state.imageBackgroundColor);
    this.props.setBannerBackgroundColor(this.state.imageBackgroundColor);
    this.setState((prev) => ({
      ...prev,
      showImageBackgroundColorModal: false,
      showImageResolutionWarningModal: false,
      showColorModalOnClickIcon: false,
      prevImageBackgroundColor: this.state.imageBackgroundColor,
    }));
  };

  handleOnClickCancelImageBackgroundColorModal = () => {
    // const bgColor = localStorage?.getItem("bgColor");
    const bgColor = this.props.bgColor;
    this.setState((prev) => {
      console.log("previous cancel", prev);
      return {
        ...prev,
        showImageBackgroundColorModal: false,
        // imageBackgroundColor: this?.props?.bannerById?.imageBackgroundColor,
        //
        // imageBackgroundColor:
        //   this.state.imageBackgroundColor &&
        //   !this.state.prevImageBackgroundColor
        //     ? this.state.imageBackgroundColor
        //     : this.state.prevImageBackgroundColor,
        //
        imageBackgroundColor:
          this.state.imageBackgroundColor &&
          !this.state.prevImageBackgroundColor
            ? bgColor
            : bgColor,
        //
        showColorModalOnClickIcon: false,
      };
    });
  };

  handleOnClickCancel = () => {
    this.setState(() => ({
      showModal: false,
      newFields: this.state.prevFields,
    }));
  };

  onClickSubmit = async (event) => {
    console.log("all state", this.state);

    //extract name of flagged items from checkedItems array
    const flaggedItems = this?.state?.checkedItems
      ?.filter((item) => item?.isFlagItem === true)
      ?.map((item) => item?.name);

    //extract id of non-flag items from checkedItems array
    const checkedItemsIds =
      this?.state?.checkedItems
        ?.filter((item) => item?.isFlagItem === false)
        ?.map((item) => item?.id) || [];

    const data = {
      file: this?.state?.file,
      titleContent: this?.state?.newFields?.title,
      subTitleContent: this?.state?.newFields?.subTitle,
      primaryBtnContent: this?.state?.newFields?.primaryBtnTitle,
      secondaryBtnContent: this?.state?.newFields?.secondaryBtnTitle,
      status: this?.state?.status?.value,
      bannerScreenId: this?.state?.bannerScreen?.value,
      checkedItem: checkedItemsIds, //includes Ids of nan flag items
      flagItems: flaggedItems, // includes name of flag items name
      imageBackgroundColor: this.state.imageBackgroundColor,
    };

    console.log("data", data);

    const titleData = {
      text: data.titleContent?.title,
      color: data.titleContent?.color,
      visible: data.titleContent?.visibility?.label,
      fontSize: data.titleContent?.fontSize,
    };

    const subTitleData = {
      text: data.subTitleContent?.subTitle,
      color: data.subTitleContent?.color,
      visible: data.subTitleContent?.visibility?.label,
      fontSize: data.subTitleContent?.fontSize,
    };

    const primaryBtnData = {
      title: data.primaryBtnContent?.primaryBtnTitle,
      color: data.primaryBtnContent?.color,
      visible: data.primaryBtnContent?.visibility?.label,
      fontSize: data.primaryBtnContent?.fontSize,
      buttonUrl: data.primaryBtnContent?.BtnActionURL,
    };

    const secondaryBtnData = {
      title: data.secondaryBtnContent?.secondaryBtnTitle,
      color: data.secondaryBtnContent?.color,
      visible: data.secondaryBtnContent?.visibility?.label,
      fontSize: data.secondaryBtnContent?.fontSize,
      buttonUrl: data.secondaryBtnContent?.BtnActionURL,
    };

    // Create an array to hold the button data
    const buttonDataArray = [primaryBtnData, secondaryBtnData];

    // Create a FormData object
    event.preventDefault();
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("title", JSON.stringify(titleData));
    formData.append("subTitle", JSON.stringify(subTitleData));
    formData.append("button", JSON.stringify(buttonDataArray));
    formData.append("status", data.status);
    formData.append("bannerTitle", titleData?.text);
    formData.append("bannerScreenId", data?.bannerScreenId);
    formData.append("subscriptionId", JSON.stringify(data?.checkedItem));
    formData.append("sahaj", data?.flagItems.includes("Sahaj")); //return true if "name" includes in flagItems
    formData.append("sky", data?.flagItems.includes("Sky")); //return true if "name" includes in flagItems
    formData.append("imageBackgroundColor", data.imageBackgroundColor);

    // // To verify, iterate through the FormData
    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`);
    //   if (key === "file") {
    //     console.log("File object details:", value);
    //   }
    // }

    this.props.updateBanner(
      this.props.bannerById._id,
      formData,
      () => {}
      // history.push("/media/banner-management")
    );
  };

  onClickCancel = () => {
    history?.goBack();
  };

  render() {
    const { deviceList, status } = this.props;

    const deviceDropDownOptions =
      deviceList?.map((item) => ({
        label: item?.name,
        value: item?.id,
      })) || [];

    const statusDropDownOptions =
      status?.map((item) => ({
        label: item?.status,
        value: item?._id,
      })) || [];

    const bannerScreenListDropDownOptions =
      this.props?.bannerScreenList?.map((item) => ({
        label: item?.label,
        value: item?._id,
      })) || [];

    return (
      <UpdateBannerView
        fields={this.state.fields}
        newFields={this.state.newFields}
        status={this.state.status}
        checkedItems={this.state.checkedItems}
        bannerScreen={this.state.bannerScreen}
        editField={this.state.editField}
        fileInput={this.state.fileInput}
        device={this.state.device}
        imageBackgroundColor={this.state.imageBackgroundColor}
        showBackGroundColorIcon={this.state.showBackGroundColorIcon}
        showModal={this.state.showModal}
        showImageResolutionWarningModal={
          this.state.showImageResolutionWarningModal
        }
        showImageBackgroundColorModal={this.state.showImageBackgroundColorModal}
        showColorModalOnClickIcon={this.state.showColorModalOnClickIcon}
        showInputElement={this.state.showInputElement}
        //
        subscriptionList={this.props.subscriptionList}
        //
        handleDoubleClickText={this.handleDoubleClickText}
        handleInputToTextOnFocusOut={this.handleInputToTextOnFocusOut}
        //
        handleFileChange={this.handleFileChange}
        handleDiscardFile={this.handleDiscardFile}
        handleInputChange={this.handleInputChange}
        handleInputChangeOfActiveModal={this.handleInputChangeOfActiveModal}
        handleColorChange={this.handleColorChange}
        handleBackgroundColorChange={this.handleBackgroundColorChange}
        handleVisibilityChange={this.handleVisibilityChange}
        handleStatusChange={this.handleStatusChange}
        handleDeviceChange={this.handleDeviceChange}
        onChangeBannerScreenOption={this.onChangeBannerScreenOption}
        handleCheckBoxChange={this.handleCheckBoxChange}
        //
        deviceDropDownOptions={deviceDropDownOptions}
        statusDropDownOptions={statusDropDownOptions}
        bannerScreenListDropDownOptions={bannerScreenListDropDownOptions}
        //
        onClickSubmit={this.onClickSubmit}
        //
        handleShowModal={this.handleShowModal}
        handleShowImageResolutionWarningModal={
          this.handleShowImageResolutionWarningModal
        }
        handleCloseImageResolutionWarningModal={
          this.handleCloseImageResolutionWarningModal
        }
        handleShowImageBackgroundColorModal={
          this.handleShowImageBackgroundColorModal
        }
        //
        handleOnClickIconShowImageBackgroundColorModal={
          this.handleOnClickIconShowImageBackgroundColorModal
        }
        handleOnClickIconConfirmImageBackgroundColorModal={
          this.handleOnClickIconConfirmImageBackgroundColorModal
        }
        handleOnClickCancelImageBackgroundColorModal={
          this.handleOnClickCancelImageBackgroundColorModal
        }
        //
        handleOnSaveClick={this.handleOnSaveClick}
        handleCloseModal={this.handleCloseModal}
        handleOnClickCancel={this.handleOnClickCancel}
        //
        resetShowInputElement={this.resetShowInputElement}
        //
        onClickCancel={this.onClickCancel}
      />
    );
  }
}

UpdateBannerContainer.propTypes = {};

const mapStateToProps = (state) => ({
  bgColor: state.bannerManagement.bgColor,
  bannerById: state.bannerManagement.bannerById,
  deviceList: state.master.deviceList,
  status: state.master.status,
  bannerScreenList: state.master.bannerScreenList,
  subscriptionList: state.master.subscriptionList,
});

export default connect(mapStateToProps, {
  getSubscriptionList,
  getBannerById,
  getDeviceList,
  getStatusList,
  updateBanner,
  getBannerScreenList,
  //
  setBannerBackgroundColor,
  resetBannerBackgroundColor,
})(UpdateBannerContainer);
